import styled from '@emotion/styled'

export const mobile = '@media (max-width: 767px)'
const font = '"Segoe UI", Arial'

const containerBase = `
  max-width: 1180px;
  margin: 0 auto;
`

const flexRow = `
  display: flex;
`

const hideScrollbar = `
  scrollbar-width: none;
  -ms-overflow-style: none;

  &::-webkit-scrollbar {
    display: none;
  }
`

export const Container = styled.section`
  ${containerBase}
  padding: 80px 10px 0;
  position: relative;

  ${mobile} {
    padding-top: 0;
  }
`

export const Wrapper = styled.div``

export const Content = styled.div``

export const Title = styled.h2`
  font: 400 35px ${font};
  color: #78be20;
  display: flex;
  margin-bottom: 20px;

  span {
    font-weight: 800;
    margin-right: 10px;
  }

  ${mobile} {
    font-size: 28px;
  }
`

export const InfoTable = styled.p`
  font: 400 18px ${font};
  width: 100%;
  margin-bottom: 20px;
`

export const TableLabel = styled.span`
  font: 800 18px ${font};
`

export const TableWrapper = styled.div`
  width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  margin-bottom: 50px;
  ${hideScrollbar}

  ${mobile} {
    border: 1px solid #eeeef0;
    border-radius: 20px;
  }
`

export const Table = styled.table`
  width: 100%;
  font-family: ${font};
  font-size: 18px;

  border: 2px solid #eeeef0;
  border-collapse: separate;
  border-spacing: 0;
  border-radius: 20px;
  overflow: hidden;

  thead {
    background: #78be20;
    color: #fff;
    font-weight: 800;

    td {
      padding: 15px 25px;
    }
  }

  td {
    border: 1px solid #eeeef0;
    padding: 15px 20px;
    font-size: 16px;
  }
`

export const TableInner = styled.div`
  ${flexRow}
  gap: 15px;
  align-items: center;
`

export const TableBG = styled.div`
  background: #eeeef0;
  padding: 10px 20px;
  border-radius: 10px;
`
